export default "__VITE_ASSET__DqnqHavB__"